import React, { useContext, useEffect, useState } from "react";
import Header from "./Comman/Header";
import { OnmaxContext } from "../OnmaxContext";
import axios from "axios";
import Pagination from "./Comman/Pagination";

export default function CommunityIncome() {
  const { account, copyaddress } = useContext(OnmaxContext);
  const [data, setdata] = useState([]);
  const [isLoading, setisLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [pages, setPages] = useState(1);

  const getData = async () => {
    if (!account) {
      return;
    }
    setisLoading(true);

    await axios.post(process.env.REACT_APP_BACKEND_LINK, {
      method: "community",
      submethod: "getbyid",
      address: account,
      key: process.env.REACT_APP_KEY,
      page: currentPage,
      pageSize: pageSize,

    })
      .then((res) => {
        console.log("ress", res.data);
        // var dedata = decryptData(res.data);
        setisLoading(false);

        if (res.data.error) {
          return "";
        }
        setdata(res.data.data);
        setPages(Math.ceil(res.data.dataLength / pageSize));

      });
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    getData();
  }, [account, pageSize, currentPage]);

    const customStyles = `
    .bg-soft-primary { 
      background-color: rgba(13, 110, 253, 0.1) !important; 
      color: #0d6efd !important; 
    }

    .bg-soft-success { 
      background-color: rgba(34, 197, 94, 0.1) !important; 
      color: #22c55e !important; 
    }
  
    .bg-soft-danger { 
      background-color: rgba(239, 68, 68, 0.1) !important; 
      color: #ef4444 !important; 
    }
  
    .text-slate-400 { 
      color: #64748b !important; 
    }
  
    .text-white-custom { 
      color: #1a2234 !important; 
    }
  
    .text-xs { 
      font-size: 11px; 
    }
  `;

  return (
    <>
      <style>{customStyles}</style>
      <div className="body-bg">
        <Header />
        <section className="nftmax-adashboard nftmax-show mt-4 setting-section">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-12">

                <div className="db-profile-card mb-5">
                  <div className="db-sec-hdr">
                    <div className="db-sec-dot"></div>
                    <div className="db-sec-title">Mining Reward</div>
                  </div>

                  <div className="card-body p-0 mt-3">
                    <div className="table-responsive">
                      <table className="table table-dashboard-premium align-middle mb-0" style={{ minWidth: '900px' }}>
                        <thead className="text-uppercase small">
                          <tr>
                            <th scope="col" className="ps-4 py-3">Sr.</th>
                            <th scope="col" className="py-3">From</th>
                            <th scope="col" className="py-3">Level</th>
                            <th scope="col" className="py-3">Reward</th>
                            <th scope="col" className="py-3">Reward 24 hrs</th>
                            <th scope="col" className="py-3">Status</th>
                            <th scope="col" className="pe-4 py-3 text-end">Date</th>
                          </tr>
                        </thead>
                        <tbody>
                          {isLoading && !data.length ? (
                            <tr>
                              <td colSpan="7" className="text-center py-5">
                                <div className="spinner-border text-primary" role="status">
                                  <span className="visually-hidden">Loading...</span>
                                </div>
                              </td>
                            </tr>
                          ) : !data.length ? (
                            <tr>
                              <td colSpan="7" className="text-center py-5 text-slate-400">
                                <p className="mb-0">No data found</p>
                              </td>
                            </tr>
                          ) : (
                            data.map((ele, i) => {
                              const index = currentPage * pageSize - pageSize + (i + 1);
                              return (
                                <tr key={i} className="table-tr-premium">
                                  <td className="ps-4">
                                    <span className="text-slate-400 small">{index}</span>
                                  </td>
                                  <td>
                                    <span
                                      className="text-primary cursor-pointer small fw-bold"
                                      onClick={() => copyaddress(ele.from)}
                                      style={{ cursor: 'pointer' }}
                                    >
                                      {ele.from} <i className="fa fa-copy ms-1"></i>
                                    </span>
                                  </td>
                                  <td>
                                    <span className="badge bg-soft-primary">{ele.level}</span>
                                  </td>
                                  <td>
                                    <span className="fw-bold text-success">${ele.income}</span>
                                  </td>
                                  <td>
                                    <span className="fw-bold text-white-custom">${ele.reward24}</span>
                                  </td>
                                  <td>
                                    <div className="d-flex flex-column">
                                      {ele.flushed && <span className="text-danger small fw-bold">Flushed</span>}
                                      {ele.gracing && <span className="text-warning small fw-bold">Gracing</span>}
                                      {!ele.flushed && !ele.gracing && <span className="text-success small fw-bold">Active</span>}
                                    </div>
                                  </td>
                                  <td className="pe-4 text-end">
                                    <span className="text-slate-400 small">{ele.createdAt}</span>
                                  </td>
                                </tr>
                              );
                            })
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div className="card-footer bg-transparent border-top border-secondary border-opacity-10 p-4">
                    <Pagination
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                      pageSize={pageSize}
                      setPageSize={setPageSize}
                      pages={pages}
                    />
                  </div>

                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
